import { useFormContext, useFormField } from '@calendly/form'
import { Button } from '@calendly/ui/components/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@calendly/ui/components/dropdown-menu'
import { IconChevronDown } from '@calendly/ui/components/glyphs/IconChevronDown'
import { UiIcon } from '@calendly/ui/components/ui-icon'
import { colorIconStandard } from '@calendly/ui/theme'
import { nanoid } from 'nanoid'
import { useState } from 'react'

import { allowsOtherChoices, hasAnswerChoices } from 'components/event_type_edit/invitee_questions'

import { getAnswerTypeMenuLabel, getQuestionTypeIcon } from './helpers'
import { QuestionTypeMenuItems } from './question_type_menu_items'
import {
  questionTypeMenuContentCss,
  questionTypeMenuStyle,
  questionTypeMenuTriggerWrapCss,
} from './styles'

const createDefaultAnswerChoices = () => (
  [...Array(3).keys()].map(() => ({
    id: nanoid(5),
    choice: '',
  }))
)

export const QuestionTypeMenu = ({
  questionIndex,
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const { setFieldValue } = useFormContext()
  const formatFieldName = `inviteeQuestions.${questionIndex}.format`
  const [{ value: format }, _, { setValue: setFormat }] = useFormField({ name: formatFieldName })
  const menuLabel = getAnswerTypeMenuLabel(format)
  const TypeIcon = getQuestionTypeIcon(format)

  const handleSelect = (nextFormat) => {
    setFormat(nextFormat)

    if (hasAnswerChoices(nextFormat)) {
      setFieldValue(`inviteeQuestions.${questionIndex}.answerChoices`, createDefaultAnswerChoices())
    } else {
      setFieldValue(`inviteeQuestions.${questionIndex}.answerChoices`, null)
    }

    if (!allowsOtherChoices(nextFormat)) {
      setFieldValue(`inviteeQuestions.${questionIndex}.include_other`, false)
    }

    setIsOpen(false)
  }

  return (
    <DropdownMenu isOpen={isOpen} onClose={() => setIsOpen(false)}>
      <DropdownMenuTrigger>
        <span className={questionTypeMenuTriggerWrapCss}>
          <Button
            appearance="secondary-outline"
            data-testid="question-type-menu-trigger"
            disabled={disabled}
            size="small"
            type="button"
            onClick={() => setIsOpen((prev) => !prev)}
          >
            <UiIcon icon={TypeIcon} size="small" color={colorIconStandard} title="" />
            {menuLabel}
            <UiIcon icon={IconChevronDown} size="small" color={colorIconStandard} title="" />
          </Button>
        </span>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className={questionTypeMenuContentCss}
        menuStyle={questionTypeMenuStyle}
        placement="bottom start"
      >
        <QuestionTypeMenuItems
          testIdPrefix="question-type-option"
          onSelect={handleSelect}
        />
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
